define('modules/editor/views/property_boxes/form_submit_format',['require','exports','module','./base','fontmanager','ldsh!../../templates/property_boxes/form_submit_format'],function(require, exports, module) {
  "use strict";
  var BasePropertyBox = require("./base"),
      FontManager = require("fontmanager");

  module.exports = BasePropertyBox.extend({
    template: require("ldsh!../../templates/property_boxes/form_submit_format"),
    helpers: function(){
      return {
        "defaultSubmitText": $.i18n.t("editor.common.submit"),
        fonts: FontManager.getNames()
      };
    }
  });

});

